<div class="failed-to-load-message brand-scrollbar">
  @if (!hideMessage) {
    <div>Some information may be missing. Try reloading the page or contacting support to resolve the issue.</div>
  }
  @if (modalData?.errorDetails) {
    <p class="max-h-8rem mt-0 mb-3 overflow-y-auto brand-scrollbar" [innerHTML]="modalData?.errorDetails"></p>
  }
  <p [innerHTML]="modalData?.message"></p>
</div>
<div class="links">
  @if (!hidePhone) {
    <div><i class="pi pi-phone icon-color"></i><span class="fw-semibold">(833) 243-4264</span></div>
  }
  <div>
    <i class="pi pi-envelope icon-color"></i>
    <a [href]="'mailto:' + supportEmail + '?subject=Loan #' + modalData.loanId + ' ' + subjectLine">
      <span class="link fw-semibold">{{ supportEmail }}</span>
    </a>
  </div>
  @if (!hideHelpDesk) {
    <div>
      <i class="pi pi-desktop icon-color"></i
      ><a href="https://helpdesk.cmgmortgage.com" target="_blank"><span class="link fw-semibold">helpdesk.cmgmortgage.com</span></a>
    </div>
  }
</div>
<div class="dialog-button-container">
  @if (action === FailedToLoadModalAction.GoToPipeline) {
    <button pButton type="button" [severity]="!hideReload ? 'secondary' : 'primary'" class="fw-bold" (click)="goToPipeline()">Go to Pipeline</button>
  }
  @if (action === FailedToLoadModalAction.GoToUrla) {
    <button pButton type="button" [severity]="!hideReload ? 'secondary' : 'primary'" class="fw-bold" (click)="goToUrla()">Go to URLA</button>
  }
  @if (action === FailedToLoadModalAction.Close) {
    <button pButton type="button" [severity]="!hideReload ? 'secondary' : 'primary'" class="fw-bold" (click)="cancel()">Close</button>
  }
  @if (action === FailedToLoadModalAction.None) {
    <button pButton type="button" [hidden]="true"></button>
  }
  @if (!hideReload) {
    <button pButton type="button" class="fw-bold" (click)="reloadPage()">Reload Page</button>
  }
</div>
